import { Suspense, type ComponentType, type ReactElement } from 'react';
import { useRemoteComponent } from 'zf-web-components';
import { customize } from '@customize';
import { getRemoteUrl } from './util';

export function canRenderSearchCenter(app: string): boolean {
  const hidden = customize.invoke('heytea.header.hideSearchCenter') === true;
  const remote = getRemoteUrl(app);
  return remote != null && !hidden;
}

export function useSearchCenter(app: string): {
  canRender: boolean;
  LazySearchCenter: ComponentType<Record<string, never>> | null;
} {
  const remote = getRemoteUrl(app);
  const { Component: LazySearchCenter } = useRemoteComponent<Record<string, never>>(remote as string, 'SearchCenter');

  return {
    canRender: canRenderSearchCenter(app),
    LazySearchCenter
  };
}

interface SearchCenterProps {
  LazySearchCenter: ComponentType<Record<string, never>>;
}

export function SearchCenter(props: SearchCenterProps): ReactElement {
  const { LazySearchCenter } = props;
  return (
    <Suspense fallback={null}>
      <LazySearchCenter />
    </Suspense>
  );
}
